import fields from "./form_json/en/noa_details.json";

export default fields;
